var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBudgetEdit = function SvgBudgetEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.907,
    height: 18.036,
    viewBox: "0 0 18.907 18.036"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#313237",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    "data-name": "Component 11 \\u2013 1"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M16.381 11.245v3.289a2.453 2.453 0 0 1-2.4 2.5H3.399a2.45 2.45 0 0 1-2.4-2.5V3.506A2.455 2.455 0 0 1 3.399 1h5.866",
    "data-name": "Path 938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.368 11.813a.473.473 0 0 1-.536-.624 28 28 0 0 1 .978-3l6.878-7.015a.51.51 0 0 1 .721.042l2.236 2.235a.51.51 0 0 1 .041.722l-6.877 7.015a27 27 0 0 1-3.441.625Z",
    "data-name": "Path 939"
  }))));
};
export default SvgBudgetEdit;